import { NavLink } from 'react-router-dom';

export default function Logo() {
    return (
        <div className="logo">
            <NavLink to="/">Jarek Skurzyński</NavLink>
        </div>
    );
}
